import { ReactElement } from 'react';

import TableComponent, { TableProps } from 'molecules/Table';

const parseTableOutput = (table: TableProps, item: ReactElement) => {
  if (item.type === 'thead') {
    table.columns = getColumns(item);
  }

  if (item.type === 'tbody') {
    table.rows = getRows(item);
  }
  return table;
};

const getColumns = (item: ReactElement) =>
  item.props?.children?.props.children.map((thead: ReactElement) => ({
    title: thead.props.children,
  }));

const getRows = (item: ReactElement) => {
  const rows = Array.isArray(item.props?.children)
    ? item.props.children
    : [item.props.children];

  return rows.map((row: ReactElement) => toDivs(row.props.children));
};

const toDivs = (children: ReactElement[]) =>
  children.map((child, index) => (
    <div key={index} {...child.props}>
      {child.props.children}
    </div>
  ));

const Table: React.FC<{ children: ReactElement[] }> = ({ children }) => {
  const { rows, columns } = children.reduce(parseTableOutput, {} as TableProps);

  return <TableComponent rows={rows} columns={columns} />;
};

export default Table;
